var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecyclable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "45px",
    viewBox: "0 0 42 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recyclable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recyclable",
    transform: "translate(0.877730, 1.159320)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: -1.42108547e-14,
    y1: 6.24557303,
    x2: 40.1313871,
    y2: 6.24557303,
    id: "Path-20",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.64802775,10.4426233 L7.41516114,39.1704069 C7.61272757,41.2214991 9.33614796,42.7868917 11.3967332,42.7868917 L29.1435007,42.7868917 C31.2316744,42.7868917 32.9684976,41.1806061 33.1313221,39.0987901 L35.3725992,10.4426233 L35.3725992,10.4426233",
    id: "Path-21",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.15653,6.24557303 L13.15653,1 C13.15653,0.44771525 13.6042452,8.53665814e-14 14.15653,8.52651283e-14 L26.1245799,8.52651283e-14 C26.6768646,8.51636752e-14 27.1245799,0.44771525 27.1245799,1 L27.1245799,3.12278652 L27.1245799,3.12278652",
    id: "Path-22",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(17.464759, 18.034605)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-23",
    points: "-1.37667655e-14 2.01971234 1.23216944 0 4.59008084 0 7.2247284 5.08552733"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-24",
    points: "8.68293626 3.20525494 7.27960628 5.20525494 4.95956421 5.20525494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(23.806227, 29.637233) rotate(118.000000) translate(-23.806227, -29.637233) translate(19.464759, 27.034605)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-23",
    points: "-1.37667655e-14 2.01971234 1.23216944 0 4.59008084 0 7.2247284 5.08552733"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-24",
    points: "8.68293626 3.20525494 7.27960628 5.20525494 4.95956421 5.20525494"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy",
    transform: "translate(14.806227, 26.902497) rotate(239.000000) translate(-14.806227, -26.902497) translate(10.464759, 24.299869)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-23",
    points: "-1.37667655e-14 2.01971234 1.23216944 0 4.59008084 0 7.2247284 5.08552733"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-24",
    points: "8.68293626 3.20525494 7.27960628 5.20525494 4.95956421 5.20525494"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecyclable);
export default __webpack_public_path__ + "static/media/recyclable.63cde6106755112fa777b60c0cdfa842.svg";
export { ForwardRef as ReactComponent };